module.exports = __webpack_public_path__ + "img/ic_pingpong_logo_normal.7e64962.png";